module.exports = "/images/eye.svg";